
 var swiper = new Swiper(".product-slider", {
  slidesPerView: 3,
  speed: 1500,
  spaceBetween: 25,
   centeredSlides: false,
  nextButton: '.swiper-button-next',
  prevButton: '.swiper-button-prev',
  loop: true,
  breakpoints: {
    1200: { slidesPerView: 2 },
    767: { slidesPerView: 1 },
  },
});



document.addEventListener("DOMContentLoaded", function () {
  const backToTopButton = document.getElementById("backToTop");
  const backToTopContainer = document.getElementById("backToTopContainer");
  const progressCircle = document.querySelector(".progress-ring__circle");
  const circumference = 2 * Math.PI * 22;

  function updateProgressBar() {
    let scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
    let scrollTop = window.scrollY;
    let progress = (scrollTop / scrollHeight) * circumference;
    progressCircle.style.strokeDashoffset = circumference - progress;

    if (scrollTop > 300) {
      backToTopContainer.style.display = "flex";
    } else {
      backToTopContainer.style.display = "none";
    }
  }

  window.addEventListener("scroll", updateProgressBar);

  backToTopButton.addEventListener("click", function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });

  updateProgressBar();
});



window.addEventListener('scroll', function () {
    const calculator = document.querySelector('.cost-calculator');
    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;
    const fullHeight = document.body.offsetHeight;

    const distanceFromBottom = fullHeight - (scrollY + windowHeight);

    if (distanceFromBottom <= 50) {
      calculator.style.display = 'none';
    } else {
      calculator.style.display = 'block';
    }
  });


